// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__2xqN0","active":"downloadDropdown_active__zFF5j"};